import { render, staticRenderFns } from "./CollapseKnowledge.vue?vue&type=template&id=a3824d1a&scoped=true"
import script from "./CollapseKnowledge.vue?vue&type=script&lang=js"
export * from "./CollapseKnowledge.vue?vue&type=script&lang=js"
import style0 from "./CollapseKnowledge.vue?vue&type=style&index=0&id=a3824d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3824d1a",
  null
  
)

export default component.exports